import React from "react";
import Jumbotron from "../../components/Jumbotron/Jumbotron";
import Mission from "../../components/Mission/Mission";
import Topbanner from "../../components/TopBanner/Topbanner";

import AbtImg from "../../assets/Image/abtImg.jpeg";
import AbtJumbo from "../../assets/Image/NewImages/B.jpeg";
import RadioXp from "../../assets/Image/ach_img9.jpeg";

import "./about.css";

import { IoArrowRedoOutline } from "react-icons/io5";

function AboutPage() {
  return (
    <div>
      <Topbanner title="About Us" Bg={AbtImg} />

      <Jumbotron
        Jumbo={AbtJumbo}
        title="Hari Subhash Raghav"
        text="Mr. H S Raghav, the founder of Samadhan, comes from Indian Air Force. He is PG in English with M Phil Degree. Has vast experience in education field. Having worked with Base Educational Services for 8+ years, he was responsible for establishing Vidya Soudha PU College at Peenya. Mentoring & Counseling students is his expertise."
        Icon={<IoArrowRedoOutline style={{ marginRight: 10 }} />}
        service1="Career Counselling"
        service2="Stress Management"
        service3="Orientation Program"
        service4="Exam Handling"
        service5="Placement Assistance"
      />

      {/* Radio Experience Section */}

      <section className="radio-section">
        <div className="container">
          <div className="row radio-row">
            {/* TEXT */}

            <div className="col s12 m12 l6 radio-text">
              <h4>Career Counseling on Radio</h4>

              <p>
                Samadhan Academy is proud to have associated with CEMCA
                (Commonwealth Educational Media Center for Asia), New Delhi.
                Choosing the right career at the right time is a huge task for
                students, especially from Semi-Urban and Rural Areas.
              </p>

              <p>
                In a special project implemented by CEMCA, Mr HS Raghav
                responded to career related questions sent by students to 5
                Radio Stations.
              </p>

              <p>
                Two stations from Rajasthan (Radio Jhunjhanu & Radio Bhiwadi),
                two from Jharkhand (Radio Khanchi & Radio Salesian), and one
                from West Bengal (Purulia Radio).
              </p>

              <p>
                Students sent their questions and Mr HS Raghav recorded the
                answers which were broadcast on the radio stations.
              </p>

              <p>
                The project ran successfully for 6 weeks and students gave
                excellent feedback.
              </p>
            </div>

            {/* IMAGE */}

            <div className="col s12 m12 l6 radio-image">
              <img src={RadioXp} alt="Radio Career Counseling" />
            </div>
          </div>
        </div>
      </section>

      <Mission />
    </div>
  );
}

export default AboutPage;
